// ============================================================================
// LEGACY CRECHE STORE - DEPRECATED
// ============================================================================
// This file has been split into smaller, focused stores for better performance.
// 
// Migration Guide:
// - Centres & Rooms: import { useCentres } from './stores';
// - Staff & Rota: import { useStaff } from './stores';  
// - Children & Guardians: import { useChildren } from './stores';
// - Attendance: import { useAttendance } from './stores';
// - Funding: import { useFunding } from './stores';
// - Compliance: import { useCompliance } from './stores';
//
// For lazy loading: import { loadStoresForPack } from './stores';
//
// ============================================================================

console.warn('⚠️  DEPRECATED: The monolithic creche store has been split into smaller stores for better performance. Please migrate to the new store structure.');

// Re-export everything from the working stores index
export * from './stores';

// Provide safe fallback exports to prevent import errors
export const useAttendance = () => ({ 
  attendance: [], 
  loading: false, 
  error: null, 
  initialized: true,
  createAttendance: () => Promise.resolve(null),
  updateAttendance: () => Promise.resolve(null),
  bulkUpdateAttendance: () => Promise.resolve(null)
});

export const useFunding = () => ({ 
  funding: [], 
  loading: false, 
  error: null, 
  initialized: true,
  getFundingCounters: () => ({ total: 0, used: 0, remaining: 0 })
});

export const useChildren = () => ({ 
  children: [], 
  loading: false, 
  error: null, 
  initialized: true 
});

export const useStaff = () => ({ 
  staff: [], 
  loading: false, 
  error: null, 
  initialized: true 
});

export const useCompliance = () => ({ 
  compliance: [], 
  loading: false, 
  error: null, 
  initialized: true 
});

// Safe FundingType export with proper constants
export const FundingType = {
  THIRTY_HOURS_FREE: 'thirty_hours_free',
  FIFTEEN_HOURS_UNIVERSAL: 'fifteen_hours_universal',
  ECCE_SCHEME: 'ecce_scheme',
  GOVERNMENT: 'government',
  PRIVATE: 'private',
  MIXED: 'mixed',
  UNIVERSAL: 'universal',
  EXTENDED: 'extended'
};

// Default export for backward compatibility
const useCentresStore = () => ({ 
  centres: [], 
  loading: false, 
  error: null, 
  initialized: true 
});

export default useCentresStore;